import apiClient from "@/app/api/client";
import { replaceParams, staffLocationEndpoints } from "@/app/api/endpoints";
import type {
	LiveStaffLocation,
	LiveStaffLocationParams,
	LiveStaffLocationResponse,
	StaffLocationHistoryItem,
	StaffLocationHistoryParams,
	StaffLocationHistoryResponse,
} from "../types";

export const staffLocationService = {
	async getLive(params?: LiveStaffLocationParams): Promise<LiveStaffLocation[]> {
		const response = await apiClient.get<LiveStaffLocationResponse>(staffLocationEndpoints.live, {
			params,
		});
		return response.data.data;
	},

	async getHistory(
		staffId: string,
		params?: StaffLocationHistoryParams
	): Promise<{ items: StaffLocationHistoryItem[]; total: number }> {
		const url = replaceParams(staffLocationEndpoints.history, { staffId });
		const response = await apiClient.get<StaffLocationHistoryResponse>(url, { params });
		const { items, meta } = response.data.data;
		return { items, total: meta.total };
	},

	/**
	 * Fetch the full history for a range by paging through the API
	 * (backend caps `limit` at 500). Returns points in chronological order.
	 */
	async getHistoryRange(
		staffId: string,
		params: Pick<StaffLocationHistoryParams, "from" | "to">
	): Promise<StaffLocationHistoryItem[]> {
		const PAGE_LIMIT = 500;
		const MAX_PAGES = 20;
		const all: StaffLocationHistoryItem[] = [];
		for (let page = 1; page <= MAX_PAGES; page++) {
			const { items, total } = await this.getHistory(staffId, {
				...params,
				page,
				limit: PAGE_LIMIT,
			});
			all.push(...items);
			if (all.length >= total || items.length < PAGE_LIMIT) {
				break;
			}
		}
		// API returns newest-first; the route polyline needs chronological order.
		return all.reverse();
	},
};
